import validate from "/Users/jflower/devProjects/uwit/node_modules/.pnpm/nuxt@3.6.5_@types+node@20.2.5_eslint@8.39.0_idb-keyval@6.2.1_typescript@5.0.4_vue-tsc@1.6.5/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}